import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useState, type ReactNode } from 'react'

interface QueryProviderProps {
	children: ReactNode
}

export function QueryProvider({ children }: QueryProviderProps) {
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						// 数据缓存 5 分钟
						staleTime: 5 * 60 * 1000,
						// 缓存保留 10 分钟
						gcTime: 10 * 60 * 1000,
						// 窗口聚焦时不自动重新获取
						refetchOnWindowFocus: false,
						// 重试次数
						retry: 1,
						// 重试延迟
						retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
					},
					mutations: {
						retry: 0,
					},
				},
			})
	)

	return (
		<QueryClientProvider client={queryClient}>
			{children}
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	)
}

export { QueryClient, QueryClientProvider }
